// Phase 6 — Track B T-B6. Query-param parsers for read-only routes.
//
// Two filters land in Phase 6 read-only routes:
//
//   * /payments — date-range filter (`from`, `to`); the canonical backend
//     route at `/modules/payments/manual` does not currently expose a date
//     range, so the web client passes the range as ISO date strings on the
//     wire and may filter client-side. The schema below validates the user
//     input shape before it touches the wire.
//
//   * /alerts — priority filter, mirrors the backend's `priorityFilterSchema`
//     enum (`'critical' | 'important' | 'info' | 'all'`).
//
// Both schemas are `.strict()`.

import { z } from 'zod';

const isoDateSchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'must be ISO date YYYY-MM-DD');

export const paymentsDateRangeSchema = z
  .object({
    from: isoDateSchema.optional(),
    to: isoDateSchema.optional(),
  })
  .strict()
  .refine(
    (v) => v.from === undefined || v.to === undefined || v.from <= v.to,
    { message: '`from` must be on or before `to`' },
  );

export type PaymentsDateRange = z.infer<typeof paymentsDateRangeSchema>;

export const alertsPriorityFilterSchema = z
  .object({
    priority: z.enum(['critical', 'important', 'info', 'all']).optional(),
    limit: z.number().int().min(1).max(200).optional(),
  })
  .strict();

export type AlertsPriorityFilter = z.infer<typeof alertsPriorityFilterSchema>;
